var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-block",
    class: {
      'info-block_product-card': _vm.productCard
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-block__text"
  }, [_c('p', {
    staticClass: "info-block-title"
  }, [_vm._v("\n      Бесплатно\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "info-block-subtitle"
  }, [_vm._v("доставим и поднимем")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-block__images"
  }, [_c('img', {
    staticClass: "info-block-icon",
    attrs: {
      "src": require("@/assets/images/svg/removebg.svg")
    }
  })]);
}]

export { render, staticRenderFns }